"use client";
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
const PushNotificationCard = () => {
  const [buttonText, setButtonText] = useState('Ativar Notificações');
  const [buttonDisabled, setButtonDisabled] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && 'Notification' in window) {
      if (Notification.permission === 'granted') {
        setButtonText('Notificações Ativadas');
        setButtonDisabled(true);
      } else if (Notification.permission === 'denied') {
        setButtonText('Notificações Bloqueadas');
        setButtonDisabled(true);
      }
    }
  }, []);

  const handleSubscribe = async () => {
    if (typeof window === 'undefined' || !('Notification' in window)) return;
    if (Notification.permission === 'denied') {
      alert('Por favor, permita as notificações nas configurações do seu navegador.');
      return;
    }
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      setButtonText('Notificações Ativadas');
      setButtonDisabled(true);
    } else {
      setButtonText('Permissão Negada');
      setButtonDisabled(true);
    }
  };

  return (
    <div className="card push-notification-card mb-4">
      <div className="card-body">
        <div className="row vertical-center">
          <div className="col-3">
            <div className="iconpush">
              <Image
                src="/bell.svg"
                alt="Ative nossas Notificações"
                width={40}
                height={40}
              />
            </div>
          </div>
          <div className="col-9">
            <h3 className="card-title">Ative nossas Notificações</h3>
            <p className="card-text">Fique por dentro das últimas notícias em tempo real!</p>
          </div>
        </div>
        <button
          id="push-subscribe"
          className="btn-primary"
          onClick={handleSubscribe}
          disabled={buttonDisabled}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default PushNotificationCard; 